export interface ModulePackage {
  uuid: string;
  name: string;
  description: string | null;
  isActive: boolean;
  moduleCode: string;
  moduleType: string | null;
  pricePerUnit: number | null;
  billingUnit: string | null;
  includedUnits: number | null;
  hasSubscriptionOption: boolean;
  priceMonthly: number | null;
  priceYearly: number | null;
  yearlyDiscountPct: number | null;
  featureFlags: Record<string, boolean> | null;
  countryCode: string | null;
  isPreferred: boolean;
  isUpsellable: boolean;
  order: number | null;
  isFree: boolean;
  createdAt: string;
  updatedAt: string;
}

export type ModulePackageBillingPeriod = 'monthly' | 'yearly';

export interface ModulePackagePricing {
  /** CarPeak's list price per vehicle for this account. */
  per_vehicle: number;

  /** Negotiated volume deal (BRIEFD-7435): this many vehicles per billing period
   *  at `volume_per_vehicle`, anything beyond at `per_vehicle`. Null = no deal.
   *  Snake_case because the pricing endpoint is not camelised. */
  volume_units?: number | null;
  volume_discount_pct?: number | null;
  volume_per_vehicle?: number | null;
}

export interface ModulePackageTier extends ModulePackage {
  isCurrent: boolean;
}

/** Standalone-billed module types — NOT gated by the product package and not
 *  consolidated onto the account's Autobrief subscription. Mirrors backend
 *  ModulePackage::isConsolidatable()'s exclusion list; keep both in sync.
 *  Shared by module-package-card.component.ts and checkout-dialog.component.ts
 *  so the list only needs to be edited once. */
export const STANDALONE_BILLED_MODULE_TYPES = ['MOBILE_APP'];

